import { render, staticRenderFns } from "./drugShortage.filter.vue?vue&type=template&id=117d7d9d&"
import script from "./drugShortage.filter.vue?vue&type=script&lang=js&"
export * from "./drugShortage.filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports